var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyVillaIcon = function SvgHappyVillaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC24A",
    stroke: "#195EB7",
    d: "M3.722 13.611h20.333v13.222H3.722zM3.722 13.396V5.43L10.334.85l6.61 4.578v7.967z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#195EB7",
    d: "M7.278 18.945h6.111v7.889H7.278z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#195EB7",
    d: "M15.667 18.445H21v3.556h-5.333z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#195EB7",
    strokeWidth: 0.5,
    d: "M18.333 11.5v1.667M20.111 11.5v1.667M21.889 11.5v1.667M23.667 11.5v1.667"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#195EB7",
    strokeLinecap: "round",
    d: "M5.195 6.487 1.346 9.151M15.336 6.37l3.8 2.488"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#195EB7",
    strokeWidth: 0.5,
    d: "M17.133 11.812h8.272"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.333,
    cy: 8.667,
    r: 1.778,
    fill: "#195EB7"
  })));
};
export default SvgHappyVillaIcon;